import { render } from "./ContactQuestionsManager.vue?vue&type=template&id=6c0ed290"
import script from "./ContactQuestionsManager.vue?vue&type=script&lang=js"
export * from "./ContactQuestionsManager.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__